interface ApiLoadingProps {
  open?: boolean;
}

const ApiLoading = (props: ApiLoadingProps) => {
  return (props.open ?? false) ? (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="flex items-center justify-center">
        <img src="/images/loading.png" alt="loading" className="w-auto h-auto" />
      </div>
    </div>
  ) : null;
};

export default ApiLoading;
